// src/services/api.js

import axios from 'axios';
import toast from 'react-hot-toast';

const api = axios.create({
  baseURL: 'https://app.universomidiadigital.com.br/api' 
});

// Adiciona o token em todas as requisições automaticamente
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Intercepta respostas para tratar bloqueios globais (Ex: 403 - Loja desativada ou assinatura suspensa)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      const mensagemErro = error.response.data?.error || "Acesso restrito, loja desativada ou assinatura suspensa.";
      toast.error(mensagemErro, { duration: 6000 });
      
      // Limpa os dados da sessão e redireciona para a tela inicial após 2 segundos
      setTimeout(() => {
        localStorage.clear();
        window.location.href = '/';
      }, 2000);
    }
    return Promise.reject(error);
  }
);

export default api;